import { STATUS } from '~/status'
import { validateIban } from '~/helper'

export default {
  hasUser (state) {
    return !!state.user?.customer
  },
  getUser (state) {
    return state.user
  },
  getCustomer (state) {
    return state.user?.customer
  },
  // Master-Riegel: bank_only blendet alle VIP-/Zusatzprodukte aus (Defense-in-Depth).
  // Backend setzt zwar alle show/allow-Flags server-seitig false/leer, dieser Getter
  // ist der zusaetzliche Frontend-Master-Riegel.
  bankOnly (state) {
    return state.user?.customer?.bank_only === true
  },
  // Ausnahme zum Master-Riegel: ist das Wuerzburger-PDF aktiv, darf der Kunde die
  // Wuerzburger-/Existenzschutz-Seite trotz bank_only sehen und unterschreiben.
  wuerzburgerPdfActive (state) {
    return state.user?.customer?.wuerzburger_pdf_active === true
  },
  // Nur fuer Blaettern/Unterschreiben (Sigma + Starpool): bank_only kuerzt den
  // Unterschriften-Flow, ausser wuerzburger_pdf_active hebt das wieder auf.
  bankOnlySignatureFlow (state, getters) {
    return getters.bankOnly && !getters.wuerzburgerPdfActive
  },
  // Zweite Ausnahme zum Master-Riegel: das CRM weicht den Versicherungsblock
  // (Creditlife, Wuerzburger, 1aPerformance, Existenzschutz) fuer bank_only auf
  // (config('smava.versicherungsprodukte_erlaubt')). Fehlt das Flag - alter
  // CRM-Stand -, bleibt es beim bisherigen Verhalten: Block aus.
  versicherungErlaubt (state) {
    return state.user?.customer?.versicherung_erlaubt === true
  },
  // Nur fuer den Versicherungsblock: bank_only blendet ihn aus, ausser
  // versicherung_erlaubt hebt das wieder auf.
  bankOnlyVersicherung (state, getters) {
    return getters.bankOnly && !getters.versicherungErlaubt
  },
  getKreditsumme (state) {
    return state.user?.customer?.money?.kreditsumme
  },
  getMonatsrate (state) {
    return state.user?.customer?.money?.mon_rate
  },
  getVertragsKreditsumme (state) {
    return state.user?.customer?.vertragsdaten?.kreditsumme
  },
  getIban (state) {
    return state.user?.customer?.money?.iban
  },
  getAuxmoney (state) {
    return state.user?.customer?.auxmoney || null
  },
  hasGermanIban (state) {
    return state.user?.customer?.money?.iban?.startsWith('DE')
  },
  hasValidIban (state) {
    return validateIban(state.user?.customer?.money?.iban)
  },
  getKdnr (state) {
    return state.user?.kdnr
  },
  kdnrEven (state) {
    return state.user?.kdnr % 2 === 0
  },
  rentner (state) {
    const birthdate = state.user?.customer?.details?.geburtstag
    if (birthdate) {
      const age = new Date().getFullYear() - new Date(birthdate).getFullYear()
      return age >= 69
    }

    return false
  },

  overFifty (state) {
    const birthdate = state.user?.customer?.details?.geburtstag
    if (birthdate) {
      const age = new Date().getFullYear() - new Date(birthdate).getFullYear()
      return age >= 50
    }

    return false
  },
  vertragsDaten (state) {
    return state.user?.customer?.vertragsdaten
  },
  getBerufsgruppen (state) {
    return state.user?.values?.berufsgruppe
  },
  // Sprachnachricht im Login: Regeln liegen im CRM (KundenloginAudioNachricht), null = keine Nachricht
  audioNachrichtKey (state) {
    const customer = state.user?.customer
    return customer?.audio_nachricht ? customer.audio_nachricht_key || null : null
  },
  // Bild-URL, ersetzt den Orb im Player
  audioNachrichtAvatar (state) {
    return state.user?.customer?.audio_nachricht_avatar || ''
  },
  bergerShow (state, getters) {
    if (getters.bankOnly) { return false }
    return state.user?.customer?.berger?.show === true
  },
  bergerSuccess (state, getters) {
    if (getters.bankOnly) { return false }
    return state.user?.customer?.berger?.success === true
  },
  hasOwnWebid (state) {
    return state.user?.customer?.vertragsdaten?.own_webid_ident || false
  },
  getUploads (state) {
    return state.user?.uploads || []
  },
  getDocuments (state) {
    return state.user?.documents || []
  },
  isDoppelt (state) {
    const lookup = [STATUS.DOPPELT]

    return lookup.includes(state.user?.status?.id)
  },
  signageNeeded (state) {
    const targetDocument = state.user?.documents?.find(doc => doc.udid === 5)
    return (
      targetDocument && targetDocument.need === 1 && targetDocument.have === 0
    )
  },
  finanzUebersichtNeeded (state) {
    const targetDocument = state.user?.documents?.find(
      doc => doc.udid === 43
    )
    return (
      targetDocument && targetDocument.need === 1 && targetDocument.have === 0
    )
  },
  baubeschreinbungNeeded (state) {
    const targetDocument = state.user?.documents?.find(
      doc => doc.udid === 40
    )
    return (
      targetDocument && targetDocument.need === 1 && targetDocument.have === 0
    )
  },
  getVersicherungGestartet (state) {
    return state.user?.versicherungs_vergleich_gestartet || false
  },
  showRsv (state, getters) {
    if (getters.bankOnly) { return false }
    return state.user?.show_rsv || false
  },
  showMa (state) {
    return state.user?.show_mitantragsteller || false
  },
  showKreditsummeAendern (state) {
    return state.user?.show_kreditsumme_aendern || false
  },
  showPlus1Angebot (state) {
    return !!state.user?.show_plus1_angebot
  },
  showPlus1Buerge (state) {
    return !!state.user?.show_plus1_buerge
  },
  showPlus1BuergeSidebar (state) {
    return !!state.user?.show_plus1_buerge_sidebar
  },
  showPlus1BuergeDanke (state) {
    return !!state.user?.show_plus1_buerge_danke
  },
  showPlus1Danke (state) {
    return !!state.user?.show_plus1_danke
  },
  showPlus1Kontakt (state) {
    return !!state.user?.show_plus1_kontakt
  },
  plus1Texte (state) {
    return state.user?.plus1_texte || null
  },
  showPlus1Ausbezahlt (state) {
    return !!state.user?.show_plus1_ausbezahlt
  },
  plus1Angebot (state) {
    return state.user?.plus1_angebot || null
  },
  showCreditoloKreditsummeBestaetigung (state) {
    return state.user?.show_creditolo_kreditsumme_bestaetigung || false
  },
  creditoloKreditsummeBestaetigungType (state) {
    return state.user?.show_creditolo_kreditsumme_bestaetigung_type || null
  },
  // smava/ffg im Status SalesForce, deren Antragssumme beim Bank-Upload gesenkt
  // wurde: einmalige Wunschsummen-Aenderung ueber /wunschsumme-aendern.
  smavaWunschsummeAenderbar (state) {
    return state.user?.show_smava_wunschsumme_aendern === true
  },
  showCreditoloKEigentumBestaetigung (state) {
    return state.user?.show_creditolo_eigentum_bestaetigung || false
  },
  getExistenzGestartet (state) {
    return state.user?.existenzschutz_gestartet || false
  },
  getExistenzschutzHigh (state) {
    return false // state.user?.existenzschutz_high || false
  },
  getExistenzschutzVariant (state) {
    return state.user?.existenzschutz_variant || 'komfort'
  },
  getFinanzSchutzbriefGestartet (state) {
    return state.user?.finanzschutzbrief_gestartet || false
  },
  // Creditlife: eigener Block neben Existenzschutz und Finanzschutzbrief.
  creditlifeMoeglich (state) {
    return state.user?.creditlife_moeglich || false
  },
  creditlifeGestartet (state) {
    return state.user?.creditlife_gestartet || false
  },
  // Nur gesetzt, wenn das CRM die Tarife schon im Status mitliefert
  // (CREDITLIFE_TARIFE_IM_STATUS). Sonst holt sie der Block selbst.
  creditlifeTarife (state) {
    return state.user?.creditlife_tarife || null
  },
  // Einzige Quelle dafuer, welcher Versicherungs-Block gerendert wird:
  // 'creditlife' | 'wuerzburger' | 'einsap'. Die Verteilung passiert im CRM,
  // das Frontend rechnet keine Prozente mehr (skag_percentage ist entfallen).
  versicherungAnbieter (state) {
    return state.user?.versicherung_anbieter ?? state.user?.customer?.versicherung_anbieter ?? null
  },
  // Redundant, sobald versicherungAnbieter ausgewertet wird – bleibt fuer die
  // Detailanzeige innerhalb des Finanzschutzes.
  finanzschutzAnbieter (state) {
    return state.user?.finanzschutz_anbieter ?? state.user?.customer?.finanzschutz_anbieter ?? null
  },
  isEinsapFinanzschutz (_state, getters) {
    return getters.finanzschutzAnbieter === 'einsap'
  },
  getNettoeinkommenGesamt (state) {
    const money = state.user?.customer?.money
    const haupt = parseFloat(money?.nettoeinkommen) || 0
    const neben = parseFloat(money?.nebeneinkommen) || 0
    return haupt + neben
  },
  getEinkommensBracket (_state, getters) {
    const sum = getters.getNettoeinkommenGesamt
    if (sum < 1300) { return 'low' }
    if (sum < 2100) { return 'mid' }
    return 'high'
  },
  needEinkommensnachweis (state) {
    const statusAusbzehaltung = state.user?.status?.id === 11

    if (statusAusbzehaltung) {
      return false
    }

    return state.user?.needEinkommensnachweis || false
  },
  einkommensnachweisUploaded (state) {
    const serverAnswer = state.user?.needEinkommensnachweis

    const upload = state.user?.uploads?.find(doc =>
      doc.filename.includes('Einkommensnachweis')
    )

    const targetDocument = state.user?.documents?.find(doc => doc.udid === 7)

    return (
      (targetDocument &&
        targetDocument.need === 1 &&
        targetDocument.have === 1) ||
      !serverAnswer ||
      upload
    )
  },

  sepaNeeded (state) {
    const sepaRequest = state.user?.documents?.find(
      doc => doc.name.includes('Unterschrift SEPA Mandat') || doc.udid === 99
    )

    return sepaRequest && sepaRequest.need === 1 && sepaRequest.have === 0
  },

  worthDigital (state) {
    const showIn = [
      STATUS.ESSEN_GENEHMIGT,
      STATUS.VERTRAGZUMKUNDEN,
      STATUS.SALESFORCE
    ]

    return showIn.includes(state.user?.status?.id)
  },

  allowDocUpload (state) {
    return state.user?.allowDocUpload || false
  },

  getVertrag (state) {
    const has = state.user?.uploads?.find(({ filename }) => {
      return (
        filename.includes('Vertrag.pdf') ||
        filename.includes('Ihr Vertragsexemplar zur Bank.pdf')
      )
    })

    return has || null
  },

  getKundenexemplar (state) {
    const has = state.user?.uploads?.find(({ filename }) => {
      return filename.includes('Ihr Kundenexemplar zum Abheften.pdf')
    })

    return has || null
  },

  getOldVertraege (state) {
    return state.user?.oldVertraege || null
  },

  showEinkommensnachweis (state) {
    const lookup = [
      STATUS.PRUFUNG,
      STATUS.ESSEN_BEARBEITUNG,
      STATUS.FEHLER,
      STATUS.SALESFORCE
    ]

    return lookup.includes(state.user?.status?.id)
  },
  hasIban (state) {
    return state.user?.customer?.money?.iban !== null
  },
  hasMitantragssteller (state) {
    return state.user?.customer?.partner?.p_vorname !== null
  },
  postIdentLink (state) {
    if (state.user?.postident) {
      return `https://postident.deutschepost.de/identportal/?vorgangsnummer=${state.user.postident}`
    }
    return `https://postident.credimaxx.eu/?kdnr=${state.user.kdnr}&email=${state.user.customer.details.email}`
  },
  currentPercentage (state) {
    return state.user?.status?.progress
  },
  currentProgress (state) {
    return `${state.user?.status?.progress ?? 0}%`
  },
  getToken (state) {
    return state.tokenWithoutBearer
  },
  /**
   * Status Getters
   */
  getStatus (state) {
    return state.user?.status
  },
  getStatusId (state) {
    return state.user?.status?.id
  },
  isSelbstaendig (state) {
    return state.user?.status?.id === STATUS.SELBSTSTANDIGE
  },
  isVertragAbgelehnt (state) {
    return state.user?.status?.id === STATUS.VERTRAGABGELEHNT
  },
  // Consors klärt den Fall selbst mit dem Kunden (B2B-Note "wir klären"). Dann
  // bei Salesforce20k keinen Termin-Button zeigen, sondern die Rückrufnummer.
  consorsWirKlaert (state) {
    return state.user?.consors_wir_klaert === true
  },
  isAuxmoney (state) {
    const lookup = [
      STATUS.AUXMONEYANFRAGE,
      STATUS.AUXMONEYINBEARBEITUNG,
      STATUS.AUXMONEYQS,
      STATUS.AUXMONEYVERTRAGERSTELLT,
      STATUS.AUXMONEYAUSBEZAHLT,
      STATUS.AUXMONEYABGELEHNT,
      STATUS.AUXMONEYFEHLER
    ]

    return lookup.includes(state.user?.status?.id)
  },
  isAuxmoneyAnfrage (state) {
    const lookup = [
      STATUS.AUXMONEYANFRAGE
    ]

    return lookup.includes(state.user?.status?.id)
  },
  isEssenPruefung (state) {
    return state.user?.status?.id === STATUS.PRUFUNG
  },
  isEssenBearbeitung (state) {
    return state.user?.status?.id === STATUS.ESSEN_BEARBEITUNG
  },

  isNegativSchufa (state) {
    return state.user?.status?.id === STATUS.NEGATIVESCHUFA
  },
  isAbgewiesen (state) {
    const lookup = [
      STATUS.PAPIERKORB,
      STATUS.VERTRAGABGELEHNT,
      STATUS.SCHWEIZ_ABGELEHNT,
      // STATUS.NEGATIVER_SPEEDCHECK,
      STATUS.NEGATIVESCHUFA
    ]

    return lookup.includes(state.user?.status?.id)
  },
  isKeineReaktion (state) {
    return state.user?.status?.id === STATUS.KEINE_REAKTION_21
  },
  isEpPruefung (state) {
    return state.user?.status?.id === STATUS.IMMO_EP_PRUFUNG
  },
  isEgtKlarung (state) {
    return state.user?.status?.id === STATUS.EGTKLARUNG
  },
  isPotentialSpaeter (state) {
    return state.user?.status?.id === STATUS.POTENTIAL_SPAETER
  },
  // Einwandbehandlung: Kunde sieht nur den Hallo-Text, Persönlichen Kontakt
  // und die Gesetzlichen Informationspflichten
  isEinwandbehandlung (state) {
    return state.user?.status?.id === STATUS.EINWANDBEHANDLUNG
  },
  isDigitalerVertrag (state) {
    return (
      state.user?.status?.id === STATUS.DIGITALERVERTRAG ||
      state.user?.customer?.allow_web_id
    )
  },
  toOldForDigital (state) {
    // date in format Y-m-d
    const exportStatus = state.user?.customer?.es || null

    if (!exportStatus) {
      return false
    }

    // if exportStatus is older than 2 months and Status is VERTRAGZUMKUNDEN
    const today = new Date()
    const exportDate = new Date(exportStatus)
    const diff = today - exportDate
    const diffInDays = diff / (1000 * 60 * 60 * 24)

    return (
      (diffInDays > 60 && state.user?.status?.id === STATUS.VERTRAGZUMKUNDEN) || diffInDays > 90
    )
  },
  showKundenexemplar (state) {
    const hasFile = state.user?.uploads?.find(({ filename }) => {
      return filename.includes('Ihr Kundenexemplar zum Abheften.pdf')
    })

    const hasVertrag = state.user?.uploads?.find(({ filename }) => {
      return filename.includes('Ihr Vertragsexemplar zur Bank.pdf')
    })

    if (
      state.user?.status?.id === STATUS.VERTRAGABGELEHNT ||
      state.user?.status?.id === STATUS.KREAKTIONRUCKTRITT
    ) {
      return false
    }

    return ((!hasFile && state.user?.customer?.vertragsdaten?.webid_qes) || hasVertrag || state.user?.status?.id === STATUS.VERTRAGZUMKUNDEN || state.user?.status?.id === STATUS.SALESFORCE || state.user?.status?.id === STATUS.VERTRAGSEINGANG)
  },
  hasVertrag (state) {
    return state.user?.customer?.vertragsdaten?.has_vertrag || false
  },
  signedDitalContract (state) {
    return state.user?.customer?.vertragsdaten?.webid_qes || false
  },
  partnerNeedsIdent (state) {
    return state.user?.customer?.needs_partner_ident || false
  },
  isDuratio (state) {
    const lookup = [STATUS.ALTERNATIVEBANKEN, STATUS.IMMO_ANDURATIOUBERGEBEN]

    return lookup.includes(state.user?.status?.id)
  },
  isDuratioVertrag (state, getters) {
    if (getters.bankOnly) { return false }
    const lookup = [STATUS.ALTERNATIVEBANKEN, STATUS.IMMO_ANDURATIOUBERGEBEN]

    return (
      lookup.includes(state.user?.status?.id) &&
      state.user?.customer?.allow_duratio_vertrag
    )
  },
  isDuratioAbgelehnt (state) {
    const lookup = [STATUS.ALTERNATIVEBANKEN, STATUS.IMMO_ANDURATIOUBERGEBEN]

    const lookup2 = [
      'Negativ extern',
      'Negativ intern',
      'Kunde tritt zurück',
      'Abgelehnt Bank'
    ]

    return (
      lookup.includes(state.user?.status?.id) &&
      lookup2.includes(state.user?.customer?.duratio_status?.status)
    )
  },
  getDuratioContractLink (state) {
    return state.user?.customer?.duratio_status?.contract_link
  },
  getDuratioStatus (state) {
    return state.user?.customer?.duratio_status?.status
  },
  positivDuratioStatus (state) {
    const lookup = [
      'In Bearbeitung',
      'Genehmigt',
      'Vertrag zum Kunden',
      'Vertrag zur Bank',
      'Unterlageneingang',
      'Abgeschlossen'
    ]

    return lookup.includes(state.user?.customer?.duratio_status?.status)
  },

  negativDuratioStatus (state) {
    const lookup = [
      'Abgelehnt Bank',
      'Negativ intern',
      'Negativ extern',
      'Abgelehnt intern',
      'Kunde tritt zurück'
    ]

    return lookup.includes(state.user?.customer?.duratio_status?.status)
  },
  isAusbezahlt (state) {
    return false // state.user?.status?.id === STATUS.KREDITWIRDAUSBEZAHLT
  },
  istAusbezahlt (state) {
    return state.user?.ausbezahlt === true
  },
  neuAnfrageMoeglich (state) {
    const lookup = [STATUS.NEGATIVESCHUFA, STATUS.KREAKTIONRUCKTRITT]

    if (state?.user?.customer?.had_contract) {
      return false
    }

    return lookup.includes(state.user?.status?.id)
  },
  zurueckAndHadContract (state) {
    return (state.user?.status?.id === STATUS.KREAKTIONRUCKTRITT && state.user.customer.had_contract) || false
  },
  isZurueckgetreten (state) {
    return state.user?.status?.id === STATUS.KREAKTIONRUCKTRITT
  },
  getName (state) {
    return `${state.user?.firstname} ${state.user?.lastname}`
  },
  getEmail (state) {
    return state.user?.customer?.details?.email
  },
  hideVersicherung (state, getters) {
    if (getters.bankOnlyVersicherung) { return true }
    return (
      state.user?.hide_versicherung || state.user?.alte_versicherung || false
    )
  },
  hasOldVersicherung (state) {
    return state.user?.alte_versicherung || false
  },
  topInsurance (state) {
    return state.topInsurance
  },
  directInsurance (state) {
    return state.directInsurance || false
  },
  olderThanFourYears (state) {
    return state.user?.olderThanFourYears || false
  },
  getPath (state) {
    return state.path
  },
  hasKids (state) {
    return (
      state.user?.customer?.details?.kinder !== null &&
      state.user?.customer?.details?.kinder !== 0
    )
  },
  hasSaaleBullsTickets (state) {
    return state.user?.saalebulls_tickets !== null || false
  },
  allowEngelVoelkers (state, getters) {
    if (getters.bankOnly) { return false }
    return state.user?.customer?.engel_voelkers?.allow || false
  },
  exportedEngelVoelkers (state, getters) {
    if (getters.bankOnly) { return false }
    return state.user?.customer?.engel_voelkers?.exported || false
  },

  allowPfando (state, getters) {
    if (getters.bankOnly) { return false }
    return state.user?.customer?.pfando?.allow || false
  },
  exportedPfando (state, getters) {
    if (getters.bankOnly) { return false }
    return state.user?.customer?.pfando?.exported || false
  },
  allowEpostfach (state) {
    return state.user?.customer?.allow_epostfach || false
  },
  forceWebId (state) {
    return state.user?.customer?.vertragsdaten?.force_webid || false
  },
  noExport (state) {
    return state.user?.customer?.no_export || false
  },
  existenschutzDbl (state) {
    return state.user?.existenschutz_dbl || false
  },
  getShowEigentumVVI (state) {
    return state.user?.show_eigentum_vvi || false
  },
  allowFinapi (state) {
    return state.user?.customer?.allow_finapi || false
  },
  getEigentum (state) {
    return state.user?.customer?.eigentum || null
  },
  // Steht fuer die WiderrufBox: true nur, wenn das CRM mindestens einen
  // widerrufbaren Vertrag (aktuell auf Versicherungen beschraenkt) meldet.
  widerrufAvailable (state) {
    return state.user?.widerruf_available || false
  },
  // Inhalt der Box "Gesetzliche Informationspflichten" (CRM: InformationspflichtenResolver).
  // DVV + VVI nur bei Vertrag mit einer direkten Kooperationsbank, Sigma-Vertrag
  // + GBV nach Auszahlung bzw. Freigabe. Die Box selbst (DSGVO) sieht jeder.
  informationspflichtenDvvVvi (state) {
    return state.user?.informationspflichten?.dvv_vvi === true
  },
  informationspflichtenSigma (state) {
    return state.user?.informationspflichten?.sigma === true
  },
  // Aktueller Zustand der Datenweitergabe an Dritte (Privatsphaere-Popup).
  dataSharingEnabled (state) {
    return state.user?.data_sharing_enabled || false
  },
  // Wohnverhaeltnis = Eigentum. Blendet den Privatsphaere-Punkt aus.
  isEigentuemer (state) {
    return state.user?.is_eigentuemer || false
  },
  showSanierungsVertrag (state, getters) {
    if (getters.bankOnly) { return false }
    return state.user?.customer?.sanierungsvertrag?.show || false
  },
  sanierungsVertragUrl (state) {
    return state.user?.customer?.sanierungsvertrag?.url || null
  },
  sanierungsVertragSuccess (state) {
    return state.user?.customer?.sanierungsvertrag?.success || false
  },
  sanierungsDuratioOverride (state) {
    return (
      state.user?.customer?.sanierungsvertrag?.has_duratio_and_was_negativ === true &&
      state.user?.customer?.duratio_status?.status === 'In Bearbeitung'
    )
  },
  sanierungsBetterHello (state) {
    return state.user?.customer?.sanierungsvertrag?.better_hello || null
  },
  sanierungsStatus (state) {
    return state.sanierungsStatus
  },
  showTilgungsvertrag (state, getters) {
    if (getters.bankOnly) { return false }
    return state.user?.customer?.schuldensanierer?.tilgungsvertrag?.allow || false
  },
  tilgungsVertragUrl (state) {
    return state.user?.customer?.schuldensanierer?.tilgungsvertrag?.url || null
  },
  tilgungsVertragSuccess (state) {
    return state.user?.customer?.schuldensanierer?.tilgungsvertrag?.success || false
  },
  tilgungsStatus (state) {
    return state.user?.customer?.schuldensanierer?.tilgungsvertrag?.status || null
  },
  tilgungsvertragIsDirect (state) {
    return state.user?.customer?.schuldensanierer?.tilgungsvertrag?.isDirect || false
  },
  showRealTilgungsvertrag (state, getters) {
    if (getters.bankOnly) { return false }
    return state.user?.customer?.schuldensanierer?.realTilgungsvertrag?.show || false
  },
  realTilgungsvertragUrl (state) {
    return state.user?.customer?.schuldensanierer?.realTilgungsvertrag?.url || null
  },
  realTilgungsvertragSuccess (state) {
    return state.user?.customer?.schuldensanierer?.realTilgungsvertrag?.success || false
  },
  showVollmacht (state, getters) {
    if (getters.bankOnly) { return false }
    return state.user?.customer?.schuldensanierer?.vollmacht?.show || false
  },
  vollmachtUrl (state) {
    return state.user?.customer?.schuldensanierer?.vollmacht?.url || null
  },
  vollmachtSuccess (state) {
    return state.user?.customer?.schuldensanierer?.vollmacht?.success || false
  },
  rsvLink (state, getters) {
    if (getters.bankOnly) { return null }
    return state.user?.customer?.rsv_link || null
  },
  eurostar (state) {
    return state.user?.customer?.eurostar || null
  },
  eurostarStatus (state) {
    return state.user?.customer?.eurostar?.status || null
  },
  sigma (state) {
    return state.user?.customer?.sigma || null
  },
  sigmaQesRequired (state) {
    return state.user?.customer?.sigma?.qes_required === true
  },
  sigmaQesSigned (state) {
    return state.user?.customer?.sigma?.qes_signed === true
  },
  // Dokumenten-Flags: bevorzugt aus /customer/status/documents, solange die noch
  // nicht geladen sind faellt es auf den (inzwischen immer null) Status zurueck.
  documentFlagsResolved (state) {
    return state.documentStatus.resolved === true
  },
  sigmaHasSignedContract (state) {
    if (state.documentStatus.resolved) {
      return state.documentStatus.sigma.has_signed_contract === true
    }
    return state.user?.customer?.sigma?.has_signed_contract ?? null
  },
  sigmaHasExistenzschutz (state) {
    if (state.documentStatus.resolved) {
      return state.documentStatus.sigma.has_existenzschutz === true
    }
    return state.user?.customer?.sigma?.has_existenzschutz ?? null
  },
  // Gilt fuer Starpool und den Eurostar-Block darin (gleicher Wert).
  starpoolHasSignedContract (state) {
    if (state.documentStatus.resolved) {
      return state.documentStatus.starpool_signed === true
    }
    return state.user?.customer?.signed_starpool ??
      state.user?.customer?.eurostar?.has_signed_contract ??
      null
  },
  // Starpool: Kunde hat die Wuerzburger unterschrieben (Kundenexemplar_wb).
  starpoolWuerzburgerSigned (state) {
    return state.documentStatus.resolved && state.documentStatus.starpool_wuerzburger_signed === true
  },
  gbvHasSignature (state) {
    if (state.documentStatus.resolved) {
      return state.documentStatus.gbv.has_signature === true
    }
    return state.user?.gbv?.has_signature ?? state.user?.customer?.gbv?.has_signature ?? null
  },
  signedStarpool (state, getters) {
    return getters.starpoolHasSignedContract === true
  },
  sigmaQesStatus (state) {
    return state.user?.customer?.sigma?.qes_status || null
  },
  sigmaContractNeedsResigning (state) {
    return state.user?.customer?.sigma?.contract_needs_resigning === true
  },
  sigmaContractResigning (state) {
    return state.user?.customer?.sigma?.contract_resigning || null
  },
  sigmaDocumentsRequested (state) {
    const sigma = state.user?.customer?.sigma
    return sigma?.package_signed === true && sigma?.documents_requested === true
  },
  showImmodatenformular (state) {
    return state.user?.show_immodatenformular === true
  },
  // Immo-Status (Liste pflegt das CRM, Status::immoTermin), in dem dem Kunden
  // die Telefontermin-Karte angeboten wird.
  showImmotermin (state) {
    return state.user?.show_immotermin === true
  },
  hasPuffer (state) {
    return state.user?.customer?.puffer != null
  },
  getPuffer (state) {
    return state.user?.customer?.puffer || null
  },
  glaubigerAufstellungNeeded (state, getters) {
    if (getters.bankOnly) { return false }
    return state.user?.customer?.schuldensanierer?.schuldensaniererData?.glaubiger_aufstellung_status === 'angefordert' || false
  },
  glaubigerAufstellungAbgesegnet (state, getters) {
    if (getters.bankOnly) { return false }
    return state.user?.customer?.schuldensanierer?.schuldensaniererData?.glaubiger_aufstellung_status === 'abgesegnet' || false
  },
  isLastschriftAktiviert (state) {
    const lookup = [STATUS.LASTSCHRIFT_AKTIVIERT, STATUS.SIGMA_AUSBEZAHLT, STATUS.SIGMA_LASTSCHRIFT_INKASSO]
    return lookup.includes(state.user?.status?.id)
  },
  needsSelfEmployedData (state) {
    const value = state.user?.needs_self_employed_data ??
      state.user?.customer?.needs_self_employed_data
    return value === 1 || value === true || value === '1'
  },
  selfEmployedLoanMatch (state) {
    const value = state.user?.self_employed_loan_match ??
      state.user?.customer?.self_employed_loan_match
    return value === 1 || value === true || value === '1'
  },
  selfEmployedDataSubmitted (state) {
    const value = state.user?.self_employed_data_submitted ??
      state.user?.customer?.self_employed_data_submitted
    return value === 1 || value === true || value === '1'
  },
  // Firmendaten (inkl. Crefo-Nummer) sind noch nicht abgeschickt.
  // Neuer GBV-Flow und alter Flow melden das über unterschiedliche Felder.
  firmendatenAusstehend (state, getters) {
    if (getters.gbvActive) {
      return getters.gbvNeedsCompanyData
    }

    return getters.needsSelfEmployedData && !getters.selfEmployedDataSubmitted
  },
  // Selbständiger (Status 65), der noch keine Crefo-Nummer hinterlegt hat.
  crefoFehlt (state, getters) {
    return getters.isSelbstaendig && getters.firmendatenAusstehend
  },
  // Kunde steckt irgendwo im Selbständigen-/Qred-Verlauf: Status 65, offene oder
  // abgeschickte Firmendaten, oder ein laufender Geschäftsbesorgungsvertrag.
  selbstaendigenFlow (state, getters) {
    return getters.isSelbstaendig ||
      getters.needsSelfEmployedData ||
      getters.selfEmployedDataSubmitted ||
      getters.gbvActive
  },
  /**
   * Geschäftsbesorgungsvertrag Selbständige (GBV).
   * Der gbv-Block aus customerstatus ist die einzige Wahrheit – kein eigener Frontend-State.
   */
  gbv (state) {
    return state.user?.gbv ?? state.user?.customer?.gbv ?? null
  },
  gbvState (state, getters) {
    return getters.gbv?.state || 'nicht_erforderlich'
  },
  // true = GBV-Schritt ist für diesen Kunden aktiv, alter Flow wird überstimmt
  gbvActive (state, getters) {
    return getters.gbv?.required === true && getters.gbvState !== 'nicht_erforderlich'
  },
  gbvNeedsCompanyData (state, getters) {
    return getters.gbv?.needs_company_data === true
  },
  gbvNeedsSignature (state, getters) {
    return getters.gbv?.needs_signature === true
  },
  gbvSigned (state, getters) {
    return getters.gbv?.signed === true
  },
  gbvBetrag (state, getters) {
    return getters.gbv?.betrag ?? null
  },
  /**
   * Vermittlungsvertrag (ehemals "GBV bei Qred").
   * Das CRM liefert die Vergütung entweder als verschachteltes verguetung-Objekt
   * ({ modus, prozent, hat_auslagen, auslagen, auslagen_text }) oder – wie bisher –
   * als flache verguetung_*-Felder im gbv-Block. Beides wird hier vereinheitlicht.
   */
  vermittlungsvertragVerguetung (state, getters) {
    const gbv = getters.gbv
    const nested = gbv?.verguetung

    if (nested && typeof nested === 'object') { return nested }

    return {
      modus: gbv?.verguetung_modus,
      prozent: gbv?.verguetung_prozent,
      text: gbv?.verguetung_text,
      hat_auslagen: gbv?.verguetung_hat_auslagen,
      auslagen: gbv?.verguetung_auslagen,
      auslagen_text: gbv?.verguetung_auslagen_text
    }
  },
  vermittlungsvertragModus (state, getters) {
    return getters.vermittlungsvertragVerguetung?.modus ?? 'prozent'
  },
  vermittlungsvertragProzent (state, getters) {
    const prozent = Number(getters.vermittlungsvertragVerguetung?.prozent)
    return Number.isFinite(prozent) && prozent > 0 ? prozent : 1.5
  },
  vermittlungsvertragText (state, getters) {
    const text = getters.vermittlungsvertragVerguetung?.text
    if (text) { return text }

    const prozent = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 })
      .format(getters.vermittlungsvertragProzent)
    return `${prozent} % der ausgezahlten Kreditsumme`
  },
  // Auslagen (z. B. Crefo-Kompaktauskunft) sind optional – ohne Betrag wird nichts angezeigt.
  vermittlungsvertragAuslagen (state, getters) {
    const verguetung = getters.vermittlungsvertragVerguetung
    if (verguetung?.hat_auslagen !== true) { return 0 }

    const auslagen = Number(verguetung?.auslagen)
    return Number.isFinite(auslagen) && auslagen > 0 ? auslagen : 0
  },
  vermittlungsvertragHatAuslagen (state, getters) {
    return getters.vermittlungsvertragAuslagen > 0
  },
  vermittlungsvertragAuslagenText (state, getters) {
    if (!getters.vermittlungsvertragHatAuslagen) { return null }
    return getters.vermittlungsvertragVerguetung?.auslagen_text || 'Auslagen'
  },
  /**
   * Eigener Schalter fürs Kundenlogin. Solange das CRM ihn nicht mitliefert,
   * gilt die bisherige Bedingung: GBV aktiv, Unterschrift fehlt, Firmendaten liegen vor.
   */
  vermittlungsvertragAktiv (state, getters) {
    if (typeof getters.gbv?.vermittlungsvertrag_aktiv === 'boolean') {
      return getters.gbv.vermittlungsvertrag_aktiv
    }
    return getters.gbvActive && getters.gbvNeedsSignature && !getters.gbvNeedsCompanyData
  },
  /**
   * Qred-Ebene. Der qred-Block kommt direkt im customerstatus mit und trägt
   * seinen eigenen Status inkl. Texten – die sind für den Hello-Text führend.
   */
  qred (state) {
    return state.user?.qred ?? state.user?.customer?.qred ?? null
  },
  qredStatusDetail (state, getters) {
    return getters.qred?.status_detail ?? null
  },
  // Kunde steckt in der Qred-Ebene, sobald das CRM einen Qred-Status mitliefert
  qredEbene (state, getters) {
    return !!getters.qredStatusDetail
  },
  qredLongDesc (state, getters) {
    return getters.qredStatusDetail?.long_desc || null
  },
  qredDescText (state, getters) {
    return getters.qredStatusDetail?.desc_text || null
  },
  // Qred-Status, in dem telefonischer Kontakt vorgesehen ist. Die Statusliste
  // pflegt das CRM (Status::telefonQred), das Login bekommt nur den Bool.
  qredTelefon (state, getters) {
    return getters.qred?.telefon === true
  },
  loanPurposePrefilled (state) {
    const value = state.user?.loan_purpose_prefilled ??
      state.user?.customer?.loan_purpose_prefilled
    return value === 1 || value === true || value === '1'
  },
  // Frontend blendet die Rechtsform-Abfrage aus, sobald das CRM meldet, dass
  // bereits eine Rechtsform hinterlegt ist. Fehlt das Flag (alter CRM-Stand),
  // wird die Abfrage sicherheitshalber gezeigt.
  rechtsformPrefilled (state) {
    const value = state.user?.rechtsform_prefilled ??
      state.user?.customer?.rechtsform_prefilled
    return value === 1 || value === true || value === '1'
  },
  krankenkasseResolved (state) {
    return state.krankenkasse.resolved
  },
  krankenkasseShow (state) {
    return false // state.krankenkasse.show
  },
  krankenkasseSubscribed (state) {
    return state.krankenkasse.subscribed
  }
}
